import { createContext, useContext, useState } from "react";
import { useToaster } from "../hooks/useToaster";

type ToasterType = "info" | "success" | "warning" | "error" | "default";
type TimeSpan = "short" | "medium" | "long";

export type ToasterState = {
  isOpen: boolean;
  message: string;
  timeSpan: TimeSpan;
  type: ToasterType;
};

export function Toaster() {
  const svgMap: Map<string, string> = new Map<string, string>([
    ["info", "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"],
    ["success", "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"],
    [
      "warning",
      "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
    ],
    [
      "error",
      "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z",
    ],
    ["default", "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"],
  ]);

  const classMap: Map<string, string> = new Map<string, string>([
    ["info", "alert-info"],
    ["success", "alert-success"],
    ["warning", "alert-warning"],
    ["error", "alert-error"],
    ["default", ""],
  ]);

  const [toasterState, openToaster, closeToaster] = useToaster();

  return (
    <div>
      {toasterState.isOpen && (
        <div role="alert" className="toast toast-end toast-top z-[60]">
          <div className={`alert ${classMap.get(toasterState.type)} `}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 shrink-0 stroke-current"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={svgMap.get(toasterState.type)}
              />
            </svg>

            <span>{toasterState.message}</span>
          </div>
        </div>
      )}
    </div>
  );
}
